
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcProgressBar as ObcProgressBarElement} from '@oicl/openbridge-webcomponents/dist/components/progress-bar/progress-bar.js';
 
 
 

 
 export const ObcProgressBar = createComponent({
   react: React,
   tagName: 'obc-progress-bar',
   elementClass: ObcProgressBarElement,
   events: {
     
   }
  });
 
 